import {StaticData} from "/src/classes/StaticData.js";

export default class ChartHelper {

  static buildDataset(chartType, queryColumns, queryResult) {
    // logger.info("ChartHelper: queryResult=", queryResult, ", queryColumns=", queryColumns)

    // get index of legend
    let legendIdx = []
    queryColumns.forEach((col, idx) => {
      if (col.chartIsLegend) legendIdx.push(idx)
    })

    let i = 1;

    const labels = legendIdx.flatMap(idx =>
      queryResult
        .map(row => Object.values(row)[idx])
        .filter(value => value != null)
    )


    let datasets = new Map()

    queryColumns.forEach((col, idx) => {
      if (idx !== legendIdx && col.name !== '__key__') {
        let chartColor = this.getChartBkgrColor(col)

        if (Object.keys(chartColor).length > 0) {
          let chartData = this.buildChartDataset(queryResult, col.name)

          if (!chartData.every(col => col == null)) {
            if (!chartColor.bkgColor) chartColor.bkgColor = "red"

            let axis = this.getAxis(queryResult, col.name)
            const stackName = col.name.includes("_STACK") ? col.name.substring(col.name.indexOf("_STACK")) : col.name

            switch (chartType) {
              case StaticData.CHART_TYPE.LINE:
                const isDashed = col.name.includes("_LINEDASH");
                datasets.set(col.name, {
                  label: col.label,
                  backgroundColor: chartColor.bkgColor,
                  borderColor: chartColor.bkgColor,
                  borderDash: isDashed ? [10, 15] : [],
                  pointBackgroundColor: chartColor.bkgColor,
                  data: this.getLineChartDataset(labels, chartData),
                  borderWidth: 2,
                  spanGaps: 1000 * 60 * 60 * 2,
                  stepped: !(axis === 'default'),
                  yAxisID: axis,
                  datalabels: {
                    display: (ctx) => {
                      return false
                    }
                  }
                })
                break;

              case StaticData.CHART_TYPE.BAR:
                datasets.set(col.name, {
                  label: col.label,
                  maxBarThickness: 180,
                  backgroundColor: chartColor.bkgColor,
                  borderColor: col.name.includes("_LINE") ? chartColor.bkgColor : chartColor.borderColor,
                  borderWidth: col.name.includes("_LINE") ? 4 : 2,
                  data: chartData,
                  fill: false,
                  stack: stackName,
                  type: col.name.includes("_LINE") ? 'line' : 'bar',
                  order: col.name.includes("_LINE") ? 1 : 2,
                  datalabels: {
                    display: (ctx) => {
                      // Nur beim letzten Dataset desselben Stacks anzeigen
                      const dsIndex = ctx.datasetIndex;
                      const currentStack = ctx.chart.data.datasets[dsIndex].stack;
                      const type = ctx.chart.data.datasets[dsIndex].type;

                      if (type === 'line' || !col.name.includes("_STACK")) return false;

                      // Finde den Index des letzten Datasets mit demselben Stack (das kein 'line' ist)
                      let lastDsIndexWithSameStack = -1;
                      ctx.chart.data.datasets.forEach((ds, index) => {
                        if (ds.stack === currentStack && ds.type !== 'line') {
                          lastDsIndexWithSameStack = index;
                        }
                      });

                      return dsIndex === lastDsIndexWithSameStack;
                    },
                    anchor: 'end',
                    align: 'end',
                    formatter: (value, ctx) => {
                      let sum = 0;
                      const currentStack = ctx.chart.data.datasets[ctx.datasetIndex].stack;

                      ctx.chart.data.datasets.forEach(ds => {
                        if (ds.stack === currentStack && ds.type !== 'line') {
                          sum += Number(ds.data[ctx.dataIndex]) || 0;
                        }
                      });
                      if (sum === 0) return '';
                      return Math.round(sum * 100) / 100;
                    }
                  },
                  yAxisID: axis
                })
                break;

              case StaticData.CHART_TYPE.PIE:
                let piebgcolor = this.getPieChartBkgrColor(queryResult, stackName)
                chartData = chartData.filter(val => val != null)
                datasets.set(col.name, {
                  label: col.label,
                  maxBarThickness: 180,
                  type: 'pie',
                  backgroundColor: piebgcolor.bgcolor,
                  borderColor: piebgcolor.bgbordercolor,
                  borderWidth: 2,
                  data: chartData,
                  weight: datasets.size === 0 ? 10 : 4
                })
                break;
            }
          }
        }
      }
    })

    //console.warn("labels:", labels, ", datasets:", datasets)
    return {labels, datasets: Array.from(datasets.values())}
  }

  static getAxis(queryResult, colname) {
    let result = 'default'
    if (queryResult && queryResult.length > 0 && queryResult[0][colname] && queryResult[0][colname].indexOf("::") !== -1) {
      result = queryResult[0][colname].split('::')[0]
    }
    return result
  }

  static getScaleY(queryResult) {
    let result = {min: null, max: null}

    if (queryResult && queryResult.length > 0) {
      if (queryResult[0]["SCALE_MIN_Y"]) {
        result.min = Number(queryResult[0]["SCALE_MIN_Y"])
      }
      if (queryResult[0]["SCALE_MAX_Y"]) {
        result.max = Number(queryResult[0]["SCALE_MAX_Y"])
      }
    }
    return result
  }

  static getLineChartDataset(labels, chartData) {
    let result = new Map()
    if (labels.length === chartData.length) {
      for (let i = 0; i < chartData.length; i++) {
        if (chartData[i] != null) {
          result.set(labels[i], {x: labels[i], y: chartData[i]})
        }
      }
    }
    return Array.from(result.values())
  }

  static getChartBkgrColor(queryColumn) {
    //let charColor = {bkgColor: this.getRandomColor(), borderColor: ""}
    let charColor = {}

    switch (queryColumn.chartColor) {
      case 1:
        charColor.bkgColor = "#E30514"; // red
        // charColor.borderColor = "#E30514";
        charColor.borderColor = "#FFFFFF";
        break;
      case 2:
        charColor.bkgColor = "#009100"; // green
        // charColor.borderColor = "#009100";
        charColor.borderColor = "#FFFFFF";
        break;
      case 4:
        charColor.bkgColor = "#FFEB55"; // yellow
        // charColor.borderColor = "#FFEB55";
        charColor.borderColor = "#FFFFFF";
        break;
      case 5:
        charColor.bkgColor = "#FF7F27"; // orange
        // charColor.borderColor = "#FF7F27";
        charColor.borderColor = "#FFFFFF";
        break;
      case 7:
        charColor.bkgColor = "#FF2971"; // pink
        // charColor.borderColor = "#FF2971";
        charColor.borderColor = "#FFFFFF";
        break;
      case 8:
        charColor.bkgColor = "#000000"; // black
        // charColor.borderColor = "#000000";
        charColor.borderColor = "#FFFFFF";
        break;
      case 9:
        charColor.bkgColor = "#C8BFE7"; // rose
        // charColor.borderColor = "#C8BFE7";
        charColor.borderColor = "#FFFFFF";
        break;
      case 11:
        charColor.bkgColor = "#beb596"; // beige
        // charColor.borderColor = "#beb596";
        charColor.borderColor = "#FFFFFF";
        break;

      case 6:
        charColor.bkgColor = "#A7A7A7"; // grey
        charColor.borderColor = "#FFFFFF";
        break;
      case 12:
        charColor.bkgColor = "#D9D9D9"; // light grey
        charColor.borderColor = "#FFFFFF";
        break;
      case 13:
        charColor.bkgColor = "#7F7F7F"; // dark grey
        charColor.borderColor = "#FFFFFF";
        break;

      case 14:
        charColor.bkgColor = "#000000"; // black
        // charColor.borderColor = "#000000";
        charColor.borderColor = "#FFFFFF";
        break;

      case 3:
        charColor.bkgColor = "#00AFE9"; // blue
        charColor.borderColor = "#FFFFFF";
        break;
      case 15:
        charColor.bkgColor = "#CAE4F1"; // light blue
        // charColor.borderColor = "#00A2E8";
        charColor.borderColor = "#FFFFFF";
        break;
      case 16:
        charColor.bkgColor = "#254864"; // dark blue
        // charColor.borderColor = "#0A1C32";
        charColor.borderColor = "#FFFFFF";
        break;

      case 17:
        charColor.bkgColor = "#8A7CD2"; // rose bright
        // charColor.borderColor = "#8A7CD2";
        charColor.borderColor = "#FFFFFF";
        break;
      case 18:
        charColor.bkgColor = "#E0DCF3"; // rose dark
        // charColor.borderColor = "#E0DCF3";
        charColor.borderColor = "#FFFFFF";
        break;
      case 19:
        charColor.bkgColor = "#FAA74B"; // orange bright
        // charColor.borderColor = "#FAA74B";
        charColor.borderColor = "#FFFFFF";
        break;
      case 20:
        charColor.bkgColor = "#FFD2B3"; // orange dark
        // charColor.borderColor = "#FFD2B3";
        charColor.borderColor = "#FFFFFF";
        break;
      case 21:
        charColor.bkgColor = "#14642B"; // green bright
        // charColor.borderColor = "#14642B";
        charColor.borderColor = "#FFFFFF";
        break;
      case 22:
        charColor.bkgColor = "#96EAAF"; // green dark
        // charColor.borderColor = "#96EAAF";
        charColor.borderColor = "#FFFFFF";
        break;
    }

    return charColor;
  }

  static getPieChartBkgrColor(queryResult, stackName) {
    const defaultBGcolor = ['#9AE1FF', '#DBF2F2', '#FFF5DD', '#FFE0E6', '#D7ECFB', '#DAD4EF', '#CEC7B0', '#F2F2F2']
    const defaultBGBordercolor = ['#00A2E8', '#6CBEBF', '#F8CE6B', '#ED6E85', '#3F48CC', '#C8BFE7', '#beb596', '#A1A1A1']

    let result = {
      bgcolor: [],
      bgbordercolor: []
    }
    try {
      if (queryResult && queryResult.length > 0) {
        let mybgcolor = []
        let mybgbordercolor = []
        queryResult.forEach(row => {
          let bgColumnName = stackName ? "bgColor" + stackName : "bgColor"
          if (row[bgColumnName]) {
            const bgcolorArr = JSON.parse(row[bgColumnName])
            mybgcolor.push(bgcolorArr[0])
            mybgbordercolor.push(bgcolorArr[1])
          }
        })
        if (mybgcolor.length > 0) result.bgcolor = mybgcolor
        else result.bgcolor = defaultBGcolor
        if (mybgbordercolor.length > 0) result.bgbordercolor = mybgbordercolor
        else result.bgbordercolor = defaultBGBordercolor
      }
    } catch (err) {
      console.error("ChartHelper getPieChartBkgrColor:", err)
    }
    return result
  }

  static buildChartDataset(queryResult, name) {
    let result = queryResult.map(row => {
      let value = row[name]
      if (value) {
        value = value.replace(",", ".")
        if (value.indexOf("::") !== -1) value = value.split('::')[1]
        if (value === '') value = null
      }
      return value
    })

    //logger.info("result: ", result, ", after:", result.filter(val=>val!=null))
    return result
  }

  static getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 3; i++) {
      color += "C" + letters[Math.floor(Math.random() * 16)];
    }
    //logger.info("random color:", color)
    return color;
  }
}
